import { render, staticRenderFns } from "./enterpriseInternalTrainingOrderView.vue?vue&type=template&id=36c9f8c6&scoped=true"
import script from "./enterpriseInternalTrainingOrderView.vue?vue&type=script&lang=js"
export * from "./enterpriseInternalTrainingOrderView.vue?vue&type=script&lang=js"
import style0 from "./enterpriseInternalTrainingOrderView.vue?vue&type=style&index=0&id=36c9f8c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c9f8c6",
  null
  
)

export default component.exports